import React, {useEffect, useState} from 'react'
import { ApiRequest } from '../../../services/api/api'
import CommonTable from '../../../components/common/common-table/common-table'
import {Button, Space} from 'antd'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const ProdInventoryReport:React.FC = () => {
  const tableColumn = [
    // { title: 'Report Id', field: 'reportId' },
    { title: 'Product Code', field: 'productCode'},
    { title: 'Product', field: 'productName' },
    { title: 'Pcs in Stock ', field: 'productInStock'},
    { title: 'Cartons in Stock ', field: 'cartonStock'},
    { title: 'Unit Price', field: 'unitPrice',render: (rowData: any) => rowData.unitPrice.toFixed(2)},
    { title: 'Value in Stock', field: 'price',render: (rowData: any) => rowData.price.toFixed(2)},
  ]

  const [dataInTable, setDataInTable] = useState<any>([])
  useDocumentTitle();
//   useEffect(() => {
//     document.title="Inventory"
// }, [])
  useEffect(() => {
      ApiRequest({
        url: 'StockMonitor/GetStockPrice',
        method: 'get',
        isShowSpinner: true
      })
      .then(res => {
        console.log('StockPrice API Response:', res.data.data)
        console.log('First item:', res.data.data?.[0])
        console.log('First item keys:', Object.keys(res.data.data?.[0] || {}))
        setDataInTable(res.data.data)
      })
  }, [])

 
  return (
    <div>
      <CommonTable title={'Inventory'} column={tableColumn} initData={dataInTable} 
      isExportable={true} defaultPageSizeOptions={[2000, 10000]}  defaultPageSize={2000}/>
    </div>
  )
}

export default ProdInventoryReport
